import { render, staticRenderFns } from "./NearestPlaceClue.vue?vue&type=template&id=4b47ffd5&scoped=true&"
import script from "./NearestPlaceClue.vue?vue&type=script&lang=js&"
export * from "./NearestPlaceClue.vue?vue&type=script&lang=js&"
import style0 from "./NearestPlaceClue.vue?vue&type=style&index=0&id=4b47ffd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47ffd5",
  null
  
)

export default component.exports